// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class CommissionResource extends Resource {
    basePath: string = 'billing/commission/';

    objectPath: string = 'billing/commission/{ident}/';

    changeStatus(data): Promise<Object> {
        return this.client._request(`${this.basePath}change_status/`, 'POST', data)
            .then((response) => response.data);
    }
}
